import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white border-top pt-5 pb-3 text-secondary">
      <section className="container px-3">
        <Row className="gy-4">
          <Col xs={12} sm={6} md={3}>
            <div className="fw-bold fs-5 text-dark mb-3">AZZ</div>
            <p className="small mb-1">© 2025 Azz Enterprise LLC</p>
          </Col>

          <Col xs={6} sm={6} md={3}>
            <div className="text-uppercase fw-semibold small mb-3 text-dark">
              Company
            </div>
            <ul className="list-unstyled small mb-0">
              <li className="mb-2">
                <Link to="/our-story" className="text-secondary text-decoration-none link-dark">
                  About
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dbs-emi" className="text-secondary text-decoration-none link-dark">
                  Emi with DBS bank
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/blog" className="text-secondary text-decoration-none link-dark">
                  Blog & Insights
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-secondary text-decoration-none link-dark">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-secondary text-decoration-none link-dark">
                  Help
                </Link>
              </li>
            </ul>
          </Col>

          <Col xs={6} sm={6} md={3}>
            <div className="text-uppercase fw-semibold small mb-3 text-dark">
              Products
            </div>
            <ul className="list-unstyled small mb-0">
              <li className="mb-2">
                <Link to="/products" className="text-secondary text-decoration-none link-dark">
                  Mobiles
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/products" className="text-secondary text-decoration-none link-dark">
                  Laptops
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/products" className="text-secondary text-decoration-none link-dark">
                  Accessories
                </Link>
              </li>
            </ul>
          </Col>

          <Col xs={12} sm={6} md={3}>
            <div className="text-uppercase fw-semibold small mb-3 text-dark">
              Connect
            </div>
            <ul className="list-unstyled small mb-0 d-flex flex-column gap-2">
              <li>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-secondary text-decoration-none link-dark">
                  Twitter
                </a>
              </li>
              <li>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-secondary text-decoration-none link-dark">
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-secondary text-decoration-none link-dark">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-secondary text-decoration-none link-dark">
                  YouTube
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-4 pt-3 border-top small text-secondary">
          <div>© 2025 Azz Enterprise. All rights reserved.</div>
          <div className="mt-2 mt-sm-0">
            <Link to="/help" className="text-secondary text-decoration-none me-3 link-dark">
              Help
            </Link>
            <Link to="/privacy-policy" className="text-secondary text-decoration-none me-3 link-dark">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="text-secondary text-decoration-none me-3 link-dark">
              Terms of Service
            </Link>
            {/* <Link to="/privacy-controls" className="text-secondary text-decoration-none link-dark">
              Privacy Controls
            </Link> */}
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
